import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-encadreurs-view',
  templateUrl: './encadreurs-view.component.html',
  styleUrls: ['./encadreurs-view.component.css']
})
export class EncadreursViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
